/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  fixDecoderSize,
  fixEncoderSize,
  getAddressDecoder,
  getAddressEncoder,
  getArrayDecoder,
  getArrayEncoder,
  getBytesDecoder,
  getBytesEncoder,
  getStructDecoder,
  getStructEncoder,
  getU8Decoder,
  getU8Encoder,
  type Address,
  type Codec,
  type Decoder,
  type Encoder,
  type ReadonlyUint8Array,
} from '@solana/kit';
import {
  getFeeRoutingMatrixDecoder,
  getFeeRoutingMatrixEncoder,
  getRehypeBeneficiaryInputDecoder,
  getRehypeBeneficiaryInputEncoder,
  type FeeRoutingMatrix,
  type FeeRoutingMatrixArgs,
  type RehypeBeneficiaryInput,
  type RehypeBeneficiaryInputArgs,
} from '.';

export type InitializeRehypeArgs = {
  namespace: Address;
  launchId: ReadonlyUint8Array;
  buybackDestination: Address;
  settlementAuthority: Address;
  routingMode: number;
  feeRouting: FeeRoutingMatrix;
  beneficiaries: Array<RehypeBeneficiaryInput>;
};

export type InitializeRehypeArgsArgs = {
  namespace: Address;
  launchId: ReadonlyUint8Array;
  buybackDestination: Address;
  settlementAuthority: Address;
  routingMode: number;
  feeRouting: FeeRoutingMatrixArgs;
  beneficiaries: Array<RehypeBeneficiaryInputArgs>;
};

export function getInitializeRehypeArgsEncoder(): Encoder<InitializeRehypeArgsArgs> {
  return getStructEncoder([
    ['namespace', getAddressEncoder()],
    ['launchId', fixEncoderSize(getBytesEncoder(), 32)],
    ['buybackDestination', getAddressEncoder()],
    ['settlementAuthority', getAddressEncoder()],
    ['routingMode', getU8Encoder()],
    ['feeRouting', getFeeRoutingMatrixEncoder()],
    ['beneficiaries', getArrayEncoder(getRehypeBeneficiaryInputEncoder())],
  ]);
}

export function getInitializeRehypeArgsDecoder(): Decoder<InitializeRehypeArgs> {
  return getStructDecoder([
    ['namespace', getAddressDecoder()],
    ['launchId', fixDecoderSize(getBytesDecoder(), 32)],
    ['buybackDestination', getAddressDecoder()],
    ['settlementAuthority', getAddressDecoder()],
    ['routingMode', getU8Decoder()],
    ['feeRouting', getFeeRoutingMatrixDecoder()],
    ['beneficiaries', getArrayDecoder(getRehypeBeneficiaryInputDecoder())],
  ]);
}

export function getInitializeRehypeArgsCodec(): Codec<
  InitializeRehypeArgsArgs,
  InitializeRehypeArgs
> {
  return combineCodec(
    getInitializeRehypeArgsEncoder(),
    getInitializeRehypeArgsDecoder(),
  );
}
